import React, { useState } from "react"
import { RadioGroup } from "@headlessui/react"

export default function Example(props) {
  const [selected, setSelected] = useState(props.termine[0])

  function handleChange(termin) {
    setSelected(termin)
    props.handleTermine(termin)
  }

  return (
    <div className="w-full">
      <div className="w-full max-w-md mx-auto">
        {/* <h5>Termin</h5> */}
        <RadioGroup value={selected} onChange={handleChange}>
          <RadioGroup.Label className="sr-only">Termine</RadioGroup.Label>
          <div className="space-y-2">
            {props.termine.map((plan) => (
              <RadioGroup.Option
                key={plan.termin}
                value={plan}
                className={({ active, checked }) =>
                  `${active ? "" : ""}
                  ${
                    checked
                      ? props.typ == "wanderreise"
                        ? "bg-[#C4AC8B] bg-opacity-75 text-[#724C2D] border-2 border-[#A88A60]"
                        : props.typ == "segelkreuzfahrt"
                        ? "bg-blue-300 bg-opacity-75 text-blue-800 border-2 border-blue-900"
                        : "bg-[#CAD7B3] bg-opacity-75 text-[#6A9129] border-2 border-[#537235]"
                      : "bg-white"
                  }
                    relative shadow-md px-5 py-4 cursor-pointer flex focus:outline-none`
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center">
                        <div className="text-sm">
                          <RadioGroup.Label
                            as="p"
                            className={`font-medium mb-4  ${
                              checked
                                ? props.typ == "wanderreise"
                                  ? "text-[#724C2D]"
                                  : props.typ == "segelkreuzfahrt"
                                  ? "text-blue-800 "
                                  : "text-[#6A9129]"
                                : "text-gray-900"
                            }`}
                          >
                            <span title={plan.fullTermin}>{plan.termin}</span> -{" "}
                            <span title={plan.fullEnde}>{plan.ende}</span>
                          </RadioGroup.Label>
                          <RadioGroup.Description
                            as="span"
                            className={`inline ${
                              checked
                                ? props.typ == "wanderreise"
                                  ? "text-[#724C2D]"
                                  : props.typ == "segelkreuzfahrt"
                                  ? "text-blue-800 "
                                  : "text-[#6A9129]"
                                : "text-gray-500"
                            }`}
                          >
                            <span>{plan.beschreibung}</span>{" "}
                            <span aria-hidden="true">&middot;</span>{" "}
                            <span>{plan.preis}€</span>
                          </RadioGroup.Description>
                        </div>
                      </div>
                      {checked && (
                        <div className="flex-shrink-0 text-[#724C2D]">
                          <CheckIcon typ={props.typ} className="w-6 h-6" />
                        </div>
                      )}
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
    </div>
  )
}

function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx={12} cy={12} r={12} fill="#fff" opacity="0.2" />
      <path
        d="M7 13l3 3 7-7"
        stroke={
          props.typ == "wanderreise"
            ? "#724C2D"
            : props.typ == "golfreise"
            ? "#6A9129"
            : "#0E41B6"
        }
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
